var _title, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgToPlan = function SvgToPlan(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-4 -4 32 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "style-three-pin-notes")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round",
    fill: "white",
    d: "M12,0C6.21,0,1.5,4.262,1.5,9.5c0,5.747,7.3,12.285,9.54,14.152a1.5,1.5,0,0,0,1.921,0C15.2,21.784,22.5,15.246,22.5,9.5,22.5,4.262,17.79,0,12,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,9h-4a.75.75,0,0,0,0,1.5h4a.75.75,0,0,0,0-1.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5,12h-4a.75.75,0,0,0,0,1.5h4a.75.75,0,0,0,0-1.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12,0C6.21,0,1.5,4.262,1.5,9.5c0,5.748,7.3,12.285,9.54,14.152a1.5,1.5,0,0,0,1.921,0C15.2,21.784,22.5,15.246,22.5,9.5,22.5,4.262,17.79,0,12,0ZM8.5,13.5a.5.5,0,0,1-.053.224l-1,2a.5.5,0,0,1-.894,0l-1-2A.5.5,0,0,1,5.5,13.5v-7a1.5,1.5,0,0,1,3,0Zm10,1A1.5,1.5,0,0,1,17,16H12a1.5,1.5,0,0,1-1.5-1.5v-8A1.5,1.5,0,0,1,12,5h5a1.5,1.5,0,0,1,1.5,1.5Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgToPlan, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/to_plan.14c61130.svg";
export { ForwardRef as ReactComponent };